module.exports = __webpack_public_path__ + "img/kanban08.9d7818c4.png";